import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import _typeof from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/typeof.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    prop: {},
    mutiple: Boolean,
    click: {},
    type: {
      default: 'tag'
    },
    defaulttext: {},
    datakey: {
      default: function _default() {
        return {
          label: 'label',
          value: 'value',
          key: 'value'
        };
      }
    },
    rule: {
      default: function _default() {
        return [{
          value: 'test',
          label: 'test',
          type: 'success'
        },
        // success  info  warning  danger
        {
          value: true,
          label: '是',
          type: 'success',
          color: 'green'
        }, {
          value: false,
          label: '否',
          type: 'success',
          color: 'red'
        }, {
          value: 0,
          label: '否',
          type: 'success',
          color: 'red'
        }, {
          value: 1,
          label: '是',
          type: 'success',
          color: 'green'
        }];
      }
    }
  },
  data: function data() {
    return {
      // tagtype: 'success',
      // tagcolor: '',
      // title: '',
      tagArr: []
    };
  },
  mounted: function mounted() {
    this.tagswitch();
  },
  methods: {
    doclick: function doclick() {
      this.$emit('click', '');
    },
    tagswitch: function tagswitch() {
      var _this = this;
      this.tagArr = [];
      var props = [];
      if (this.mutiple) {
        console.log('mutiplemutiplemutiplemutiple', this.prop);
        props = _typeof(this.prop) === 'object' ? this.prop : this.prop.split(',');
      } else {
        props.push(this.prop);
      }
      this.title = this.defaulttext || '';
      var SIGN = '，';
      props.forEach(function (prop) {
        for (var i = 0; i < _this.rule.length; i++) {
          if (_this.rule[i][_this.datakey.value] + '' === prop + '') {
            _this.tagArr.push({
              title: _this.rule[i][_this.datakey.label] || _this.title,
              tagtype: _this.rule[i].type || 'success',
              tagcolor: _this.rule[i].color || ''
            });
          }
        }
      });
    }
  },
  watch: {
    'prop': function prop(val, oldValue) {
      this.tagswitch();
    },
    'rule': function rule(val, oldValue) {
      this.tagswitch();
    }
  }
};